import { render, staticRenderFns } from "./TopParticipants.vue?vue&type=template&id=a2138e40&"
import script from "./TopParticipants.vue?vue&type=script&lang=js&"
export * from "./TopParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports